import firebase from "datastore/database";
import store from "datastore/store";

export default function observeGroupBusinesses(groupBuid) {
  store.dispatch({ type: "ADD_GROUP_BUSINESSES_LOADING" });

  return firebase
    .firestore()
    .collection("business-groups")
    .doc(groupBuid)
    .onSnapshot(
      async (snapshot) => {
        try {
          if (!snapshot.exists) {
            throw new Error("Group not found");
          }

          const groupData = snapshot.data();
          const businessUids = groupData.uids || [];

          if (businessUids.length === 0) {
            store.dispatch({
              type: "ADD_GROUP_BUSINESSES_SUCCESS",
              data: [],
            });
            return;
          }

          const db = firebase.firestore();
          const businessesRef = db.collection("businesses");
          const subscriptionsRef = db.collection("subscriptions");

          const batchPromises = businessUids.map((uid) => {
            const businessPromise = businessesRef.doc(uid).get();
            const subscriptionPromise = subscriptionsRef.doc(uid).get();
            return Promise.all([businessPromise, subscriptionPromise]).then(
              ([businessDoc, subscriptionDoc]) => {
                if (businessDoc.exists) {
                  const tier = subscriptionDoc.exists
                    ? subscriptionDoc.data().tier
                    : null;
                  return {
                    uid: businessDoc.id,
                    name: businessDoc.data().name,
                    address: businessDoc.data().address,
                    tier,
                  };
                }
                return null;
              }
            );
          });

          const results = await Promise.all(batchPromises);
          const validGroupBusinesses = results.filter(
            (business) => business !== null
          );

          store.dispatch({
            type: "ADD_GROUP_BUSINESSES_SUCCESS",
            data: validGroupBusinesses,
          });
        } catch (error) {
          store.dispatch({ type: "ADD_GROUP_BUSINESSES_ERROR", error });
        }
      },
      (error) => {
        store.dispatch({ type: "ADD_GROUP_BUSINESSES_ERROR", error });
      }
    );
}
